<template>
  <div>
    <van-sticky>

      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">体测预约列表</div>
      </nav-bar>

      <van-cell title="添加时间段" size="large" is-link to="AddTestBooking"/>

      <van-cell title="选择日期" size="large" :value="calendarDate" @click="calendarShow = true"/>
      <van-calendar :min-date="minDate" :max-date="maxDate" v-model="calendarShow" :formatter="calendarFormatter"
                    @confirm="onCalendarConfirm"/>

    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in BookingList" :key="item.id">
          <template slot="left">
            <!--            <van-button square type="primary" @click="modifyVenue(item)"  text="修改"/>-->
          </template>
          <van-cell :border="false" :label="'最大人数:'+item.maxp"
                    :title="item.title+item.time" value="<<滑动<<"/>
          <template slot="right">
            <van-button square type="danger" @click="delPhyTest(item.id)" text="删除"/>
            <van-button square type="info" @click="ViewStudents(item)" text="人员"/>
            <van-button square type="primary" @click="lookPhyTest(item.id)" text="详情"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>
    <van-action-sheet v-model="descriptionShow" :title="this.title+' 体测场馆'+' 当前人数:'+this.countp">
      <van-notice-bar wrapable left-icon="volume-o">
        <p>预约开始时间 {{ new Date(this.startTime).toLocaleString() }}</p>
        <p>体测开始时间 {{ new Date(this.openTime).toLocaleString() }}</p>
        <p>体测关闭时间'{{ new Date(this.closeTime).toLocaleString() }}</p>
      </van-notice-bar>
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        '体测场馆位置' {{ this.location }}
      </van-notice-bar>
      <van-cell-group inset>
        <van-cell v-for="(item,index) in getConditions" :title="'条件'+(index+1)" :key="index">
          <template #label>
            <p> 年级:{{ item.grade }}</p>
            <p> 学院(部):{{ item.school }}</p>
            <p> 层次:{{ item.level }}</p>
          </template>
        </van-cell>
      </van-cell-group>
      <div style="  padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.description }}</div>

      <div style="padding-top: 50px"></div>
    </van-action-sheet>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Picker,
  CellGroup,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  ActionSheet,
  NoticeBar,
  Sticky,
  Empty, Calendar
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Sticky);
Vue.use(Empty);
Vue.use(Calendar);
import {getPhyTestList, DelPhyTestById, GetPhyTestCountById,GetPhyTestCalendarList} from "@/network/test_booking";
import {DelVenueById, GetVenueCalendarList} from "@/network/venue";

export default {
  name: "TestBookingManageList",
  components: {
    NavBar
  },
  activated() {
    let now = new Date();
    this.years = now.getFullYear();
    this.months = now.getMonth() + 1;
    this.days = now.getDate();
    this.calendarDate = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
    this.getPhyTestLists();
    this.getPhyTestCalendarList();
  },
  data() {
    return {
      //booking list
      BookingList: [],

      //Calendar 日历
      calendarShow: false,
      calendarDate: '',
      minDate: this.GLOBAL.start_select_time,
      maxDate: this.GLOBAL.end_select_time,
      years: 2020,
      months: 9,
      days: 1,

      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      title: "",
      location: "",
      grade: "",
      school: "",
      level: "",
      startTime: "",
      openTime: "",
      closeTime: "",
      description: "",
      conditions: "",
      countp: 0,

      phyTestCalendarList: [],
    }
  },
  computed: {
    getConditions() {
      let conditions = this.conditions;
      let s1 = conditions.split(':');
      let c = [];
      for (let i = 0; i < s1.length; i++) {
        let s2 = s1[i].split('-')
        c.push({grade: s2[0], school: s2[1], level: s2[2]});
      }
      return c;
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/more");
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.BookingList = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getPhyTestLists();
        this.isLoading = false;
      }, 1000);
    },
    async getPhyTestCalendarList() {
      const res = await GetPhyTestCalendarList();
      this.phyTestCalendarList = res;
    },
    calendarFormatter(day) {
      const year = day.date.getFullYear();
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();

      for (let item of this.phyTestCalendarList) {
        if (year == item.year && month == item.month && date == item.day) {
          day.topInfo = '体测:' + item.count+'个';
          return day;
        }
      }
      // day.bottomInfo = '离店';
      // day.text = '今天';

      return day;
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onCalendarConfirm(date) {
      this.years = date.getFullYear();
      this.months = date.getMonth() + 1;
      this.days = date.getDate();
      this.getPhyTestLists();
      this.calendarDate = this.formatDate(date);
      this.calendarShow = false;
    },
    parseDate(date) {
      if (date >= 10)
        return date;
      return '0' + date;
    },
    getPhyTestLists() {
      getPhyTestList(this.years, this.months, this.days).then(res => {
        this.BookingList = res;
        for (let i = 0; i < this.BookingList.length; i++) {
          let d1 = new Date(parseInt(this.BookingList[i].opHours));
          let d2 = new Date(parseInt(this.BookingList[i].clHours));
          let time = ' ' + this.parseDate(d1.getHours()) + ':' + this.parseDate(d1.getMinutes()) + '-' + this.parseDate(d2.getHours()) + ':' + this.parseDate(d2.getMinutes());
          this.BookingList[i]['time'] = time;
        }
      })
    },
    delPhyTest(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelPhyTestById(id).then(res => {
            if (res) {
              this.BookingList = this.BookingList.filter(item => item.id != id);
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    ViewStudents(item) {
      this.$router.push({
        path: 'PhyTestStudents',
        query: {id: item.id, title: item.title, years: item.years, months: item.months, days: item.days}
      })
    },
    lookPhyTest(id) {
      let phyTest = this.BookingList.filter(item => item.id === id)[0];
      this.vid = phyTest.id;
      this.title = phyTest.title;
      this.location = phyTest.location;
      this.grade = phyTest.grade;
      this.school = phyTest.school;
      this.level = phyTest.level;
      this.startTime = phyTest.bkTime;
      this.openTime = phyTest.opHours;
      this.closeTime = phyTest.clHours;
      this.description = phyTest.notice;
      this.conditions = phyTest.conditions;
      GetPhyTestCountById(phyTest.id).then(res => {
        this.countp = res;
      })
      this.descriptionShow = true;
    },
  }
}
</script>

<style scoped>

</style>
